import styled from 'styled-components';

export const BannerContainer = styled.div(
  props => `
  flex-direction: row;
  justify-content: space-between;
  display: flex;
  flex-wrap: wrap;
  align-items:center;
  border-radius: ${props.theme.misc.borderRadius.large};
  background-color: ${props.theme.colors.blue.lightBlue};
  padding:${props.theme.spacing.large.l20};
  margin-top:${props.theme.spacing.large.l15};
`,
);

export const TextWrap = styled.div(
  props => `

  font-size:${props.theme.font.large.font16};
  font-family: ${props.theme.font.fontFamily};
  color:${props.theme.colors.goBrand.blue};
  font-weight:bold;
  margin-left:${props.theme.spacing.large.l20}
`,
);

export const BannerLeftWrap = styled.div`
  display: flex;
  align-items: center;
  width: 75%;
`;

export const ButtonWrap = styled.button(
  props => `
  padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l15};
  background-color: ${props.theme.colors.white.base};
  color:${props.theme.colors.goBrand.blue};
  border-radius: ${props.theme.misc.borderRadius.base};
  cursor: pointer;
  justify-content: space-around;
  border:none;
  font-size:${props.theme.font.large.font14};
  font-family: ${props.theme.font.fontFamily};
  color:${props.theme.colors.goBrand.blue};
  font-weight:bold;
`,
);
